import { useEffect } from "react";

const useWindowInFocus = ({
  onFocus,
  onBlur,
}: {
  onFocus: () => void;
  onBlur?: () => void;
}) => {
  useEffect(() => {
    window.addEventListener("focus", onFocus);
    if (onBlur) window.addEventListener("blur", onBlur); // onFocus();

    return () => {
      window.removeEventListener("focus", onFocus);
      if (onBlur) window.removeEventListener("blur", onBlur);
    };
  }, [onBlur, onFocus]);

  return <div />;
};

export default useWindowInFocus;
